/*
 * @Autor: fengqi
 * @Date: 2019-10-08 14:54:30
 * @LastEditors: wtt
 * @LastEditTime: 2021-06-04 15:21:28
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from '@/plugins/http'
import utils from '@/utils/utils'
import getWXSign from '@/utils/wx'
import { Toast } from 'mint-ui'
import 'mint-ui/lib/style.css'
import '../src/assets/css/index.css'
import VuewechatTitle from 'vue-wechat-title'
Vue.use(VuewechatTitle)


Vue.prototype.$Toast = window.$Toast = Toast
Vue.prototype.$http = window.$http = http
Vue.prototype.$utils = window.$utils = utils
getWXSign()

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
